module.exports = __webpack_public_path__ + "img/AufDenFersen.de89af14.jpg";